export const DATA_VIEW_MODES = {
  TABLE: "table",
  GRID: "grid",
};
